<ng-container *transloco="let t">
  <app-loader [loading]="loading === true"></app-loader>
  <div class="p-grid p-fluid statistics-filter" *ngIf="loading !== true">

    <div class="p-col-4">
      <app-form-control [cid]="'templates'" [control]="form.get('templates')" [type]="'multiselect'" [label]="t('common.labels.procedure')" [options]="optionsTemplates" optionLabel="name" [showClear]="true"></app-form-control>
    </div>
    <div class="p-col-8">
      <app-form-control [cid]="'exercises'" [control]="form.get('exercises')" [type]="'multiselect'" [label]="t('common.labels.exercises')" [showAllSelected]="true" [options]="optionsExercises" optionLabel="name" [showClear]="true"></app-form-control>
    </div>

    <div class="p-col-4">
      <div class="p-grid">
        <div class="p-col-6">
          <app-form-control [cid]="'start'" [control]="form.get('start')" [type]="'date-month'" [label]="t('common.labels.start')" [minDate]="minDate" [maxDate]="maxDate"></app-form-control>
        </div>
        <div class="p-col-6">
          <app-form-control [cid]="'end'" [control]="form.get('end')" [type]="'date-month'" [label]="t('common.labels.end')" [showClear]="true" [minDate]="minDate" [maxDate]="maxDate"></app-form-control>
        </div>
      </div>
    </div>
    <div class="p-col-8">
      <app-form-control [cid]="'onlinetests'" [control]="form.get('onlinetests')" [type]="'multiselect'" [label]="t('common.labels.onlinetests')" [showAllSelected]="true" [options]="optionsOnlinetests" optionLabel="name" [showClear]="true"></app-form-control>
    </div>

    <div class="p-col-4">
      <app-form-control [cid]="'gender'" [control]="form.get('gender')" [type]="'select'" [label]="t('common.labels.gender')" [showClear]="true" [options]="optionsGenders"></app-form-control>
    </div>
    <div class="p-col-8">
      <app-form-control [cid]="'competences'" [control]="form.get('competences')" [type]="'multiselect'" [label]="t('common.labels.competences')" [showAllSelected]="true" [options]="optionsCompetences" [optionLabel]="'name.' + language" [showClear]="true"></app-form-control>
    </div>

    <div class="p-col-4" *ngIf="optionsCandidatetypes !== null">
      <app-form-control [cid]="'candidatetype'" [control]="form.get('candidatetype')" [type]="'select'" [label]="t('common.labels.candidate_type')" [showClear]="true" [options]="optionsCandidatetypes"></app-form-control>
    </div>
    <div class="p-col-8" *ngIf="optionsRecommendations !== null">
      <app-form-control [cid]="'recommendations'" [control]="form.get('recommendations')" [type]="'multiselect'" [label]="t('common.labels.recommendations')" [showAllSelected]="true" [options]="optionsRecommendations" [optionLabel]="'name.' + language" [showClear]="true"></app-form-control>
    </div>

    <div class="p-col-4 p-mt-4">
      <button pButton [label]="t('common.labels.clear_filters')" (click)="onResetForm()" class="p-button-outlined" style="max-width: 180px;"></button>
    </div>
    <div class="p-col-4 p-offset-4 p-mt-4 p-text-right">
      <button pButton [label]="t('common.labels.show_results')" (click)="onSubmit()" [disabled]="form.valid ? null : true" style="max-width: 180px;"></button>
    </div>

  </div>
</ng-container>
